import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { obtenerPeticionesFacturasReferenciaAction } from "../../../ducks/clientesDuck"
import { useEffect } from "react"
import { Alert } from "@material-ui/lab"
import { formatDinero } from "../../../utils/formatDinero"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ButtonDowloadComSituacionFiscal from "../../Facturas/TFacturas/ButtonDowloadComSituacionFiscal"

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});
const VFacturas = () => {
    const { facturas, cliente, referencia } = useSelector(store => store.cliente)
    const classes = useStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerPeticionesFacturasReferenciaAction({ referencia: referencia }))
    }, [dispatch, referencia])

    if (!referencia) return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )
    return (
        <div>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Nombre</TableCell>
                            <TableCell align="center">Monto</TableCell>
                            <TableCell align="center">Estatus Paquete</TableCell>
                            <TableCell align="center">Razón social</TableCell>
                            <TableCell align="center">Regimen fiscal</TableCell>
                            <TableCell align="center">C.P.</TableCell>
                            <TableCell align="center">RFC</TableCell>
                            <TableCell align="center">Fisica</TableCell>
                            <TableCell align="center">Moral</TableCell>
                            <TableCell align="center">Estatus</TableCell>
                            <TableCell align="center">Documento</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {facturas.map((row, index) => (
                            <TableRow key={row.IdFactura}>
                                <TableCell align='center'>
                                    {`${row?.Nombre} ${row?.Apellidos}`}
                                </TableCell>
                                <TableCell align='center'>
                                    {`${formatDinero(row?.Meta?.Paquete?.Cotizacion?.Suma)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}
                                </TableCell>
                                <TableCell align='center'>
                                    {`${row?.Meta?.Paquete?.EstatusProceso?.Descripcion}`}
                                </TableCell>
                                <TableCell align="center">
                                    {row?.RazonSolcial}
                                </TableCell>
                                <TableCell align='center'>
                                    {row?.CatRegimenFiscal?.Descripcion}
                                </TableCell>
                                <TableCell align="center">
                                    {`${row?.CodigoPostal}`}
                                </TableCell>
                                <TableCell align="center">
                                    {`${row?.RFC}`}
                                </TableCell>
                                <TableCell align='czenter'>
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {row?.EsFisica && <CheckCircleIcon color='secondary' />}
                                    </div>
                                </TableCell>
                                <TableCell align='center'>
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {row?.EsMoral && <CheckCircleIcon color='secondary' />}
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    {`${row?.CatEstatusFactura?.Descripcion}`}
                                </TableCell>
                                <TableCell align="center">
                                    <ButtonDowloadComSituacionFiscal
                                        IdFactura={row?.IdFactura}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default VFacturas